class CountdownTimer extends HTMLElement {
  static get observedAttributes() {
    return ['datetime'];
  }

  connectedCallback() {
    this.unitEls = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  attributeChangedCallback(name) {
    if (name === 'datetime' && this.isConnected) this.start();
  }

  start() {
    this.stop();
    this.target = this.parseTarget();
    if (!this.target) return;
    this.tick();
    this.intervalId = setInterval(() => this.tick(), 1000);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  parseTarget() {
    const raw = this.getAttribute('datetime');
    if (!raw) return null;
    const t = new Date(raw).getTime();
    return Number.isFinite(t) ? t : null;
  }

  tick() {
    const diff = Math.max(0, this.target - Date.now());
    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.setUnit('days', days);
    this.setUnit('hours', hours);
    this.setUnit('minutes', minutes);
    this.setUnit('seconds', seconds);

    if (diff === 0) {
      this.stop();
      this.dispatchEvent(new CustomEvent('countdown:end', { bubbles: true }));
    }
  }

  setUnit(name, value) {
    const el = this.unitEls[name];
    if (!el) return;
    el.textContent = String(value).padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
